import React from 'react'

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'

import { Omit } from 'types'

interface Props extends SvgIconProps {
  direction?: 'up' | 'down'
}

const EventRankingItemDeltaIconUp: React.SFC<Omit<Props, 'direction'>> = (props) => (
  <SvgIcon {...props}>
    <defs>
      <clipPath id="_clipPath_VxxMynPaRlFLum4MG1K4XJVrHlY3kOWM">
        <rect width="24" height="24"/>
      </clipPath>
    </defs>
    <g clipPath="url(#_clipPath_VxxMynPaRlFLum4MG1K4XJVrHlY3kOWM)">
      <polygon points="12,9.304,24,22,0,22" />
    </g>
  </SvgIcon>
)

const EventRankingItemDeltaIconDown: React.SFC<Omit<Props, 'direction'>> = (props) => (
  <SvgIcon {...props}>
    <defs>
      <clipPath id="_clipPath_CEJpStBOASqzRuj7rhpQWsoH9SdEet7m">
        <rect width="24" height="24"/>
      </clipPath>
    </defs>
    <g clipPath="url(#_clipPath_CEJpStBOASqzRuj7rhpQWsoH9SdEet7m)">
      <polygon points="12,22,0,9.304,24,9.304" />
    </g>
  </SvgIcon>
)

const EventRankingItemDeltaIcon: React.SFC<Props> = ({ direction, ...props }) => (
  direction === 'up' ? <EventRankingItemDeltaIconUp {...props} /> : <EventRankingItemDeltaIconDown {...props} />
)

EventRankingItemDeltaIcon.defaultProps = {
  direction: 'up',
}

export default EventRankingItemDeltaIcon
